module.exports = __webpack_public_path__ + "static/consolegroup-382367ccfbef0b6ad8615f818d5fec42.png";